import { EntityStatusBadgeVariant } from '@frontend/common';
import { EquipmentState } from '@frontend/equipment/types';
import React from 'react';

import { EquipmentStateBadgeProps } from './equipment-state-badge.component';

interface ViewProps {
    displayName: React.ReactNode;
    variant: EntityStatusBadgeVariant;
}

export const useEquipmentStateBadge = (props: EquipmentStateBadgeProps): ViewProps => {
    return {
        displayName: EquipmentState.getByValue(props.state)?.displayName || 'Unknown',
        variant: EquipmentState.getBadgeVariant(props.state)
    };
};
